import { Dialog, LinearProgress, Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';

const styles = theme => ({
  root: {
    flexGrow: 1,
    margin: theme.spacing(4),
    alignItems: 'center',
    alignContent: 'center',
  },
  progress: {
    margin: theme.spacing(2),
    backgroundColor: 'white',
    opacity: 0.4,
  },
});

function LinearProgressBlockScreen () {
  return (
    <div>
      <Dialog open><Typography /></Dialog>
      <LinearProgress color='primary' />
    </div>
  );
}
export default withStyles(styles)(LinearProgressBlockScreen);
